import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Grid, Menu, MenuItem } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ChevronDown from '@material-ui/icons/KeyboardArrowDown';

const useStyles = makeStyles((theme) => ({
  dark: {
    color: theme.palette.primary.main,
    '& *': {
      color: theme.palette.primary.main,
    },
  },
  button: {
    variant: 'outlined',
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid #8D98A2`,
    borderRadius: 0,
    color: '#2D3741',
    '& svg': {
      color: ' #2D3741',
    },
    fontFamily: 'Trade Gothic LT STD',
    '& span': {
      fontFamily: 'Trade Gothic LT STD',
      color: '#2D3741',
    },
  },
  light: {
    color: theme.palette.tertiary.main,
    background: 'none',
  },
  orange: {
    marginTop: '60px',
  },
  icon: {
    color: '#2D3741',
  },
}));

function LanguageSelector() {
  const { i18n } = useTranslation('common');

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [lang, setLang] = React.useState(i18n.language);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const chooseLang = (langChoosen) => {
    setLang(langChoosen);
    localStorage.setItem('language', langChoosen);
    i18n.changeLanguage(langChoosen);
    handleClose();
  };

  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item className={classes.button}>
        <Button
          aria-controls="language-menu"
          aria-haspopup="true"
          onClick={handleClick}
          className={isMobile ? classes.light : classes.dark}
          style={{ padding: 0 }}
        >
          <span>{lang}</span>
          <ChevronDown style={{ color: ' #2D3741' }} className={classes.icon} />
        </Button>
      </Grid>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={classes.orange}
        style={{ padding: 4 }}
      >
        <MenuItem
          className={classes.button}
          onClick={() => {
            chooseLang('en');
          }}
        >
          EN
        </MenuItem>
        <MenuItem
          className={classes.button}
          onClick={() => {
            chooseLang('it');
          }}
        >
          IT
        </MenuItem>
      </Menu>
    </Grid>
  );
}

export default LanguageSelector;
